import gql from 'graphql-tag';

export const DAILY_REPORT_QUERY = gql`
  query dailyProjectReportJoined(
    $filter: DailyProjectReportFilter
    $first: Int
    $sort: [DailyProjectReportSort!]
    $after: String
  ) {
    dailyProjectReports(filter: $filter, first: $first, sort: $sort, after: $after) {
      id
      cursor
      projectId
      project {
        id
        title
        rootProjectId
        depth
        ancestors {
          id
          title
          depth
        }
        children {
          id
          title
          depth
        }
      }
      createdBy
      createdByMember {
        id
        firstName
        lastName
      }
      reportDate
      reportEndDate
      fileUrl
      templateId
      template {
        id
        title
        sections
        deletedOn
      }
      createdOn
      deletedOn
    }
  }
`;

export const SIMPLE_DPR_QUERY = gql`
  query simpleDailyProjectReportJoined(
    $filter: DailyProjectReportFilter
    $first: Int
    $sort: [DailyProjectReportSort!]
    $after: String
  ) {
    dailyProjectReports(filter: $filter, first: $first, sort: $sort, after: $after) {
      id
      deletedOn
    }
  }
`;

export const DAILY_REPORT_TEMPLATE_QUERY = gql`
query DailyProjectReportTemplate(
  $filter: DailyProjectReportTemplateFilter,
  $sort: [DailyProjectReportTemplateSort!],
  $first: Int,
  $pageNumber: Int,
  $after: String
) {
  dailyProjectReportTemplates(
    filter: $filter,
    sort: $sort,
    first: $first,
    pageNumber: $pageNumber,
    after: $after
  ) {
    id
    cursor
    positionId
    organizationId
    audienceType
    sections
    title
    appearance
    createdOn
    submittedOn
    updatedOn
    position {
      id
      title
    }
  }
}
`;
